import { useEffect, useState } from "react";
import { getFacetsCountFromPostgres } from "../../../../api/postgreSQL/postCalls/getFacetsCountFromPostgres";
import { SearchForMedicalPaOrdersFromPostgresParams } from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";

/** Fetch Pending J-code counts with the table's tenant, assignee and cross-filter scope. */
export function useDocStatusCounts(
  tabId: string | undefined,
  payload: SearchForMedicalPaOrdersFromPostgresParams | null,
  refreshKey: unknown,
) {
  const [counts, setCounts] = useState<Record<string, number>>();
  const [error, setError] = useState(false);
  const payloadKey = JSON.stringify(payload);
  useEffect(() => {
    setCounts(undefined);
    setError(false);
    if (tabId !== "pending" || !payload) return;
    const controller = new AbortController();
    const { doc_status: _ownFilter, ...facet_filters } =
      payload.facet_filters ?? {};
    getFacetsCountFromPostgres(
      {
        org_id: payload.org_id,
        facet_attributes: ["doc_status"],
        facet_filters,
        timezone_offset: payload.timezone_offset,
        date_of_work_start: payload.date_of_work_start,
        date_of_work_end: payload.date_of_work_end,
        date_of_service_start: payload.date_of_service_start,
        date_of_service_end: payload.date_of_service_end,
        created_at_start: payload.created_at_start,
        created_at_end: payload.created_at_end,
      },
      controller.signal,
    )
      .then((result) => {
        if (controller.signal.aborted) return;
        if (!result.facet_results?.doc_status)
          throw new Error("Doc Status counts were not returned");
        setCounts(result.facet_results.doc_status);
      })
      .catch(() => {
        if (!controller.signal.aborted) setError(true);
      });
    return () => controller.abort();
  }, [tabId, payloadKey, refreshKey]);
  return { counts, error };
}
